import { render, staticRenderFns } from "./StepperHeader.vue?vue&type=template&id=45acb95e&scoped=true&"
import script from "./StepperHeader.vue?vue&type=script&lang=js&"
export * from "./StepperHeader.vue?vue&type=script&lang=js&"
import style0 from "./StepperHeader.vue?vue&type=style&index=0&id=45acb95e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45acb95e",
  null
  
)

export default component.exports